import React, {Component} from 'react';
import axios from "axios";
import Select from "react-select";
import Button from "react-bootstrap/Button";

import classes from'./DevelopersInput.module.css';
import NewDeveloper from "../NewDeveloper/NewDeveloper";
import apiUrl from "../../../shared/config";

class DevelopersInput extends Component  {
    state = {
        developers: [],
        selected_developers: [],
        new_developer: false
    };

    componentDidMount() {
        if (this.state.developers !== []) {
            axios.get(apiUrl +'Developers/getDevelopers')
                .then(response => {
                    this.setState({developers: response.data});
                });
        }
        this.setState({selected_developers: this.props.gameDevelopers});
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps !== this.props) {
            this.setState({selected_developers: this.props.gameDevelopers})
        }
    }

    addDeveloper = () => {
        this.setState(
            {selected_developers: [
                    ...this.state.selected_developers,
                    {
                        game_developer_id: null
                    }]
            });
    };

    newDeveloperToggle = () => {
        this.setState({new_developer: !this.state.new_developer});
    };

    newDevelopersHandler = (new_developer) => {
        this.setState({developers: [new_developer, ...this.state.developers]});
    };

    arraySearch(arr,val) {
        for (let i = 0; i < arr.length; i++) {
            if (arr[i].value === val)
                return i;
        }
        return -1;
    }

    render() {
        let developersInputElement = null;
        if (this.state.developers && this.state.developers.length) {
            const developerOptions = this.state.developers
                .map( developer => ({value: developer.game_developer_id, label: developer.game_developer_name}));

            if (this.state.selected_developers && this.state.selected_developers.length) {
                let developers_index = 0;
                let selected_developers = [...this.state.selected_developers];
                developersInputElement = (
                    <React.Fragment>
                        <dd className="col-sm-9">
                            {selected_developers.map(game => {
                                let developers_index_local = developers_index;
                                const developer_id = selected_developers[developers_index_local].game_developer_id;
                                const default_index = this.arraySearch(developerOptions, developer_id);
                                let default_value = {label: "Add a developer for this game."};
                                if (developer_id !== null) {
                                    default_value = developerOptions[default_index];
                                }
                                const developer_jsx = (
                                    <div className={classes.DevelopersBlock} key={developer_id}>
                                        <Select
                                            className={classes.DevelopersSelect}
                                            defaultValue={{
                                                value: selected_developers[developers_index_local].game_developer_id,
                                                label: default_value.label,
                                                isFixed: true,
                                                isDisabled: true
                                            }}
                                            options={developerOptions}
                                            closeMenuOnSelect={true}
                                            onChange={(val) => {
                                                let developers_local = [...selected_developers];
                                                developers_local[developers_index_local] = {
                                                    game_developer_id: val.value
                                                };
                                                this.setState({selected_developers: developers_local});
                                                this.props.developersUpdate(developers_local);
                                            }}
                                        />
                                        <div className={classes.DeleteDevelopers}>
                                            <Button className={classes.DeleteDevelopersButton} size="sm" variant={"outline-danger"} onClick={() => {
                                                let filtered_array = selected_developers.filter((value,index,array) => {
                                                    return index !== (developers_index_local)
                                                });
                                                this.setState({selected_developers: filtered_array});
                                                this.props.developersUpdate(filtered_array);
                                            }}>X</Button>
                                        </div>
                                    </div>
                                );
                                developers_index++;
                                return developer_jsx;
                            })}
                        </dd>
                        <dt className="col-sm-3"> </dt>
                    </React.Fragment>
                );
            }
        }
        let new_developer_jsx = '';
        if (this.state.new_developer === true) {
            new_developer_jsx = (<NewDeveloper
                developers={this.state.developers}
                newDeveloperToggle={this.newDeveloperToggle}
                onNewDeveloper={this.newDevelopersHandler}
            />);
        }
        const add_disabled = (this.state.new_developer || this.state.selected_developers.filter(developer => developer.game_developer_id === null).length !== 0);

        return (
            <dl className="row">
                <dt className="col-sm-3"><label>Developers</label></dt>
                {developersInputElement}
                {new_developer_jsx}
                <dd className="col-sm-6"><Button className="col-sm-12" variant="outline-primary" onClick={this.addDeveloper} disabled={add_disabled}>Add Developer to Game</Button></dd>
                <dd className="col-sm-3"><Button className="col-sm-12" variant="outline-secondary" onClick={this.newDeveloperToggle} disabled={this.state.new_developer}>Enter New Developer</Button></dd>
            </dl>
        );
    }
}

export default DevelopersInput;